<template>
  <div style="width: 100%;" v-loading.body="loading" element-loading-text="Loading..." id="poreport">
      <el-row type="flex" align="middle" justify="end" class="headerRow">
        <el-col>
          <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
            PURCHASE ORDER REPORTING
          </el-row>
        </el-col>
        <el-col class="small">
            <a @click="showJson = ! showJson">.&nbsp;</a>
        </el-col>
        <el-col>
          <el-row type="flex" align="middle" justify="end">
            <el-button plain @click="generateReport" :disabled="disableReportRun">
              Run report
            </el-button>
          </el-row>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="end" class="headerRow">
        <el-col>
          <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
            Report Options
          </el-row>
        </el-col>
      </el-row>

      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Report Type<sup>*</sup>
        </el-col>
        <el-col :span="8">
          <el-radio-group v-model="reportOptions.type" @change="updateReportType">
            <el-radio-button label="detail">Detail</el-radio-button>
            <el-radio-button label="summary">Summary</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Sort Type<sup>*</sup>
        </el-col>
        <el-col :span="8">
          <el-radio-group v-model="reportOptions.sort" @change="updateReportType">
            <el-radio-button label="account">By Account</el-radio-button>
            <el-radio-button label="transaction">By Transaction</el-radio-button>
            <el-radio-button label="po">By PO Number</el-radio-button>
            <!-- <el-radio-button label="vendor">By Vendor</el-radio-button> -->
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Periods/Dates
        </el-col>
        <el-col :span="21">
          <el-radio-group v-model="reportOptions.dates" @change="updateReportDates">
            <el-radio-button label="datesAll">All</el-radio-button>
            <el-radio-button label="datesPeriod">Period</el-radio-button>
            <el-radio-button label="datesPosted">Posting Date</el-radio-button>
            <el-radio-button label="datesEffective">Effective Date</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <div v-if="reportOptions.dates==='datesPeriod'" class="m-top-20">
        <el-row type="flex" align="middle" justify="start">
          <el-col :span="3"></el-col>
          <el-col :span="4">Starting Period</el-col>
          <el-col :span="3"></el-col>
          <el-col :span="4">Ending Period</el-col>
        </el-row>
        <el-row type="flex" align="middle" justify="start">
          <el-col :span="3"></el-col>
          <el-col :span="4">
            <el-select v-model="selectedCodes.period_start" :multiple="false" placeholder="First Period">
              <el-option
                v-for="opt in allCodes.periods"
                :key="opt.id"
                :label="opt.id + ' - ' + opt.start"
                :value="opt.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3"></el-col>
          <el-col :span="4">
            <el-select v-model="selectedCodes.period_end" :multiple="false" placeholder="Last Period">
              <el-option
                v-for="opt in allCodes.periods"
                :key="opt.id"
                :label="opt.id + ' - ' + opt.start"
                :value="opt.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>

      <div v-if="reportOptions.dates==='datesPosted'" class="m-top-20">
        <el-row type="flex" align="middle" justify="start">
          <el-col :span="3" />
          <el-col :span="4">Posting Date Start</el-col>
          <el-col :span="3" />
          <el-col :span="4">Posting Date End</el-col>
        </el-row>
        <el-row type="flex" align="middle" justify="start">
          <el-col :span="3" />
          <el-col :span="4">
            <DateField v-model="selectedCodes.time_posted_start" />
            <!-- <el-input v-model="selectedCodes.time_posted_start" placeholder="2001-01-01"/>-->
          </el-col>
          <el-col :span="3" />
          <el-col :span="4">
            <DateField v-model="selectedCodes.time_posted_end" />
            <!-- <el-input v-model="selectedCodes.time_posted_end" placeholder="2099-12-31"/>-->
          </el-col>
        </el-row>
      </div>

      <div v-if="reportOptions.dates==='datesEffective'" class="m-top-20">
        <el-row type="flex" align="middle" justify="start">
          <el-col :span="3" />
          <el-col :span="4">Effective Date Start <sup>**</sup></el-col>
          <el-col :span="3" />
          <el-col :span="4">Effective Date End <sup>**</sup></el-col>
        </el-row>
        <el-row type="flex" align="middle" justify="start">
          <el-col :span="3" />
          <el-col :span="4">
            <DateField v-model="selectedCodes.effective_date_start" />
            <!-- <el-input v-model="selectedCodes.effective_date_start" placeholder="2001-01-01"/>-->
          </el-col>
          <el-col :span="3" />
          <el-col :span="4">
            <DateField v-model="selectedCodes.effective_date_end" />
            <!-- <el-input v-model="selectedCodes.effective_date_end" placeholder="2099-12-31"/>-->
          </el-col>
        </el-row>
        <el-row v-if="reportOptions.dates==='datesEffective'" type="flex" align="middle" justify="start">
          <el-col :span="3" />
          <el-col :span="21"><p><sup>**</sup> Posting Date is used if Effective Date is not Set</p></el-col>
        </el-row>
      </div>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          PO Status<sup>*</sup>
        </el-col>
        <el-col :span="8">
          <el-radio-group v-model="reportOptions.status" @change="updateReportType">
            <el-radio-button label="open">Open</el-radio-button>
            <el-radio-button label="all">All</el-radio-button>
            <el-radio-button label="closed">Closed</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Batch
        </el-col>
        <el-col :span="7">
          <el-select filterable clearable multiple v-model="selectedCodes.batch_id" placeholder="All" @change="updateBatch">
            <el-option
              v-for="opt in batches"
              :key="opt.id"
              :label="opt.id + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Company
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="selectedCodes.company_id"
            :multiple="false" placeholder="All">
            <el-option
              v-for="opt in allCodes.companies"
              :key="opt.id"
              :label="opt.code + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="right">
          Production
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="selectedCodes.production_id"
            :multiple="true" placeholder="All">
            <el-option
              v-for="opt in allCodes.productions"
              :key="opt.id"
              :label="opt.code + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Series
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="selectedCodes.series_id"
            :multiple="true" placeholder="All">
            <el-option
              v-for="opt in allCodes.series"
              :key="opt.id"
              :label="opt.code + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="right">
          Location
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="selectedCodes.location_id"
            :multiple="true" placeholder="All">
            <el-option
              v-for="opt in allCodes.locations"
              :key="opt.id"
              :label="opt.code + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Set
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="selectedCodes.set_id"
            :multiple="true" placeholder="All">
            <el-option
              v-for="opt in allCodes.sets"
              :key="opt.id"
              :label="opt.code + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="right">
          Free Field
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="selectedCodes.free_field_1_id"
            :multiple="true" placeholder="All">
            <el-option
              v-for="opt in allCodes.freefield1"
              :key="opt.id"
              :label="opt.code + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row v-if="(allCodes.currencies||[]).length > 1" type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Currency
        </el-col>
        <el-col :span="4">
          <el-select v-model="selectedCodes.currency_id" :multiple="true" placeholder="All">
            <el-option
              v-for="opt in currencies"
              :key="opt.id"
              :label="opt.code + ' - ' + parseFloat(opt.rate_vs_usd || 0).toFixed(4)"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="right">
          Convert To
        </el-col>
        <el-col :span="4">
          <el-select v-model="reportOptions.report_currency_id">
            <el-option
              v-for="opt in currencies"
              :key="opt.id"
              :label="opt.code + ' - ' + parseFloat(opt.rate_vs_usd || 0).toFixed(4)"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div class="clear"></div>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Report Output
        </el-col>
        <el-col :span="4">
          <el-select v-model="reportOptions.format">
            <el-option
              v-for="opt in reportOutputFormats"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="end" class="section">
        <el-col>
          <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
            Vendor Selection
          </el-row>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="24" :offset="1">
          <el-radio-group v-model="reportOptions.vendorQuickPick" @change="updateVendors" :disabled="loading || disableReportRun">
            <el-radio-button label="custom">Custom</el-radio-button>
            <el-radio-button label="all">All</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row v-show="reportOptions.vendorQuickPick==='custom'" type="flex" align="top" justify="start" class="headerRow">
        <el-col :span="24" :offset="1">
          <el-transfer
            ref="vendorTransfer"
            v-model="selectedCodes.vendor_id"
            :data="vendors"
            :titles="[ 'Unselected Vendors', 'Selected Vendors' ]"
            :props="{ key: 'id', label: 'display_name' }"
            filterable
            filter-placeholder="Search Vendors"
          >
          </el-transfer>
          <!--
            :filter-method="filterMethod"
          -->
        </el-col>
      </el-row>
      <div class="clear"></div>
      <el-row type="flex" align="middle" justify="end" class="section">
        <el-col>
          <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
            Account Selection
          </el-row>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="24" :offset="1">
          <el-radio-group v-model="reportOptions.accountQuickPick" @change="updateAccounts" :disabled="loading || disableReportRun">
            <el-radio-button label="custom">Custom</el-radio-button>
            <el-radio-button label="all">All</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row v-show="reportOptions.accountQuickPick==='custom'" type="flex" align="top" justify="start" class="headerRow">
        <el-col :span="24" :offset="1">
          <el-transfer
            ref="accountTransfer"
            v-model="selectedCodes.account_id"
            :data="accounts"
            :titles="[ 'Unselected Accounts', 'Selected Accounts' ]"
            :props="{ key: 'id', label: 'display_name' }"
            filterable
            filter-placeholder="Search Accounts"
          >
          </el-transfer>
          <!--
            :filter-method="filterMethod"
          -->
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="end" class="headerRow">
        <el-col>
          <p><sup>*</sup> Required</p>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-if="showJson">
          <textarea id="output" style="width: 100%; height: 500px;" v-model="prettyJson"></textarea>
          <el-button plain @click="generateCustomReport" :disabled="disableReportRun">
            Run Customized Report
          </el-button>
        </el-col>
      </el-row>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { sortObjectByProperty } from '../../utils/helpers/ObjectSorting'
  import { capitalizeFirstLetter } from '../../utils/helpers/StringOperations'
  import { reportMixins } from '../../Mixins/Reports'
  import DateField from '@/components/InputComponents/DateField.vue'

  export default {
    name: 'poReport',
    components: { DateField },
    mixins: [ reportMixins ],
    props: {
    },
    data () {
      const { getJasperHost } = this.$store.getters
      return {
        reportOptions: {
          transactionStatuses: [ 'posted' ],
          accountQuickPick: 'all',
          vendorQuickPick: 'all',
          type: 'detail',
          dates: 'datesAll',
          sort: 'account',
          status: 'open',
          format: 'pdf',
          reportFunction: 'buildGlReport',
          report_currency_id: 1
        },
        result: [],
        allCodes: [],    // Show codes, e.g. accounts, series, locations, sets, etc.
        selectedCodes: {
          batch_id: [],
          period_start: undefined,
          period_end: undefined,
          time_posted_start: undefined,
          time_posted_end: undefined,
          effective_date_start: undefined,
          effective_date_end: undefined,
          account_id: [],
          vendor_id: [],
          series_id: [],
          location_id: [],
          set_id: [],
          free_field_1_id: [],
          free_field_2_id: [],
          free_field_3_id: [],
          free_field_4_id: [],
          company_id: undefined,
          production_id: [],
          source_code_id: [],
          asset: undefined,
          currency_id: []
        },
        batches: [],
        batchNames: [],
        jasperSettings: {
          reportServer: `${getJasperHost}rest_v2/reports/Revolution/Phoenix/`,
          reportName: 'general_ledger_detail',
          reportTitle: 'All Purchase Orders',
          reportSubtitle: 'Sorted by Account'
        },

        reportOutputFormats: [
          { value: 'pdf', label: 'PDF' },
          { value: 'csv', label: 'CSV' }
        ],

        vendors: undefined,

        transactionTypes: {     // Types of transactions and whether we need them or not
          'aps': { name: 'AP', include: false },
          'jes': { name: 'JE', include: false },
          'pcs': { name: 'PC', include: false },
          'pos': { name: 'POFULL', include: true },
          'cks': { name: 'CK', include: false }
        },
        unserializedData: {      // Raw data from API
          aps: {
            headers: {},
            lines: {}
          },
          jes: {
            headers: {},
            lines: {}
          },
          pcs: {
            headers: {},
            lines: {}
          },
          cks: {
            headers: {},
            lines: {}
          },
          pos: {
            headers: {},
            lines: {}
          }
        },
        disableReportRun: false, // Disable run report button if false
        reportJson: undefined,
        prettyJson: undefined,
        showJson: false,
        reportNotif: undefined,
        collapseExpenses: false,
        loading: false
      }
    },

    computed: {
      username () { return this.$store.getters.getUser.username },
      includedTypes () { return Object.values(this.transactionTypes).filter(types => types.include === true).map(type => type.name) },
      accounts () {
        let accountsNew = []
        for (let i in this.allCodes.accounts) {
          if (this.allCodes.accounts[i].type.toLowerCase() === 'header') continue
          accountsNew[i] = this.allCodes.accounts[i]
          accountsNew[i]['display_name'] = this.allCodes.accounts[i]['code'] + ' - ' + this.allCodes.accounts[i]['name']
        }
        return accountsNew
      },
      currencies () {
        if (typeof this.allCodes.currencies !== 'undefined' && this.allCodes.currencies.length > 0) {
          return sortObjectByProperty(this.allCodes.currencies, 'id')
        } else {
          return []
        }
      },
      seriesNames () {
        const selected = (this.allCodes.series || []).filter((ser) => this.selectedCodes.series_id.includes(ser.id))
        if (selected.length === 0) return 'All'
        else return selected.map((ser) => ser.name).join(', ')
      },
      locationNames () {
        const selected = (this.allCodes.locations || []).filter((loc) => this.selectedCodes.location_id.includes(loc.id))
        if (selected.length === 0) return 'All'
        else return selected.map((loc) => loc.name).join(', ')
      },
      setNames () {
        const selected = (this.allCodes.sets || []).filter((set) => this.selectedCodes.set_id.includes(set.id))
        if (selected.length === 0) return 'All'
        else return selected.map((set) => set.name).join(', ')
      },
      freeFieldNames () {
        const selected = (this.allCodes.freefield1 || []).filter((ff) => this.selectedCodes.free_field_1_id.includes(ff.id))
        if (selected.length === 0) return 'All'
        else return selected.map((ff) => ff.code).join(', ')
      },
      dateStart () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start) || {}).start || '0000/00/00'

          case 'datesEffective':
            return this.selectedCodes.effective_date_start || '0000/00/00'

          case 'datesPosted':
            return this.selectedCodes.time_posted_start || '0000/00/00'

          default:
            return 'All'
        }
      },
      dateEnd () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end) || {}).end || '9999/99/99'

          case 'datesEffective':
            return this.selectedCodes.effective_date_end || '9999/99/99'

          case 'datesPosted':
            return this.selectedCodes.time_posted_end || '9999/99/99'

          default:
            return 'All'
        }
      }
    },

    methods: {
      resetComponent () {
        this.reportJson = this.vendors = undefined
        this.clearStore()
      },
      clearStore () {
        // TODO
      },
      updateReportType (type) {
        let reportStyle
        let reportTitle
        let reportSubtitle

        if (this.reportOptions.sort === 'account') {
          reportStyle = 'general_ledger_' + this.reportOptions.type
          reportTitle = 'Purchase Order Report'
          reportSubtitle = 'Sorted by ' + capitalizeFirstLetter(this.reportOptions.sort)
          this.reportOptions.reportFunction = 'buildGlReport'
        } else if (this.reportOptions.sort === 'transaction') {
          reportStyle = 'po_open_transaction'
          reportTitle = 'Purchase Order Report'
          reportSubtitle = 'Sorted by ' + capitalizeFirstLetter(this.reportOptions.sort)
          this.reportOptions.reportFunction = 'buildTransReport'
        } else if (this.reportOptions.sort === 'vendor') {
          reportStyle = 'vendor_history_' + this.reportOptions.type
          reportTitle = 'Purchase Order Report'
          reportSubtitle = 'Sorted by ' + capitalizeFirstLetter(this.reportOptions.sort)
          this.reportOptions.reportFunction = 'buildVendorReport'
        } else if (this.reportOptions.sort === 'po') {
          reportStyle = 'po_open_transaction'
          reportTitle = 'Purchase Order Report'
          reportSubtitle = 'Sorted by PO'
          this.reportOptions.reportFunction = 'buildPoReport'
        }

        if (this.reportOptions.status === 'all') this.reportOptions.transactionStatuses = [ 'POSTED', 'CLOSED', 'VOIDED' ]
        else if (this.reportOptions.status === 'open') this.reportOptions.transactionStatuses = [ 'POSTED' ]
        else if (this.reportOptions.status === 'closed') this.reportOptions.transactionStatuses = [ 'CLOSED' ]

        this.jasperSettings.reportName = reportStyle
        this.jasperSettings.reportTitle = reportTitle
        this.jasperSettings.reportSubtitle = reportSubtitle
      },
      updateBatch (selection) {
        this.batchNames = []
        selection.filter((sel) => {
          this.batches.filter((batch) => {
            if (batch.id === sel && !this.batchNames.includes(batch.name)) {
              this.batchNames.push(batch.name)
            }
          })
        })
      },
      updateAccounts (type) {
        if (!type) return false
        switch (type) {
          case 'none':
            this.disableReportRun = false
            this.selectedCodes.account_id = []
            break
          case 'all':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.map(acct => acct.id)
            break
          case 'expenses':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => type.toLowerCase().match('expense')).map(acct => acct.id)
            break
          case 'balance':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => {
              if (type.toLowerCase().match('asset') || type.toLowerCase().match('liability') || type.toLowerCase().match('income')) return true
            }).map(acct => acct.id)
            break
          case 'custom':
            this.disableReportRun = false
            break
          default:
            return undefined
        }
        // The transfer table is one tick behind.  Force update now
        this.$forceUpdate()
        return true
      },
      updateVendors (type) {
        if (!type) return false
        switch (type) {
          case 'none':
            this.disableReportRun = true
            this.selectedCodes.vendor_id = []
            break
          case 'all':
            this.disableReportRun = false
            this.selectedCodes.vendor_id = this.vendors.map(vendor => vendor.id)
            break
          case 'custom':
            this.disableReportRun = false
            break
          default:
            return undefined
        }
        // The transfer table is one tick behind.  Force update now
        this.$forceUpdate()
        return true
      },
      addExpenseAccounts () {
        this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => type.match('EXPENSE')).map(acct => acct.id)
      },
      selectReportFormat ({target}) {
        if (target.checked) {
          this.reportOptions.format = 'csv'
        } else {
          this.reportOptions.format = 'pdf'
        }
      },
      buildTransReport (sortedTransactions) {
        return new Promise((resolve, reject) => {
          let json = {
            'report': {
              report_name: this.jasperSettings.report_name,
              report_title: this.jasperSettings.reportTitle,
              report_subtitle: this.jasperSettings.reportSubtitle,
              printed_by: this.username,
              date_run: this.today(),
              company: (this.selectedCodes.company_id) ? (this.allCodes.companies.find(({id}) => id === this.selectedCodes.company_id).name) : this.allCodes.companies[0].name,
              project:
                this.selectedCodes.production_id && this.selectedCodes.production_id.length
                ? this.allCodes.productions.filter((prod) => this.selectedCodes.production_id.includes(prod.id)).map((prod) => prod.name).join(', ')
                : this.allCodes.productions[0].name,
              // period: (this.selectedCodes.period_start || 'Beginning') + ' - ' + (this.selectedCodes.period_end || 'End'),
              period: this.dateStart + ' - ' + this.dateEnd,
              date_start: this.dateStart,
              date_end: this.dateEnd,
              currency: (this.reportOptions.report_currency_id) ? (this.allCodes.currencies.find(({id}) => id === this.reportOptions.report_currency_id).code) : this.currencies[0].code,
              // date_start: (this.selectedCodes.period_start) ? (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start).start) : '0000/00/00',
              // date_end: (this.selectedCodes.period_end) ? (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end).end) : this.today(),
              transactions: 'All',
              batchNames: this.selectedCodes.batch_id.length ? this.batchNames.join(', ') : 'All',
              episodes: (this.selectedCodes.series_id && this.selectedCodes.series_id.length > 0) ? (this.allCodes.series.find(({id}) => this.selectedCodes.series_id.includes(id)).code) : 'All',
              seriesNames: this.seriesNames,
              locations: (this.selectedCodes.location_id && this.selectedCodes.location_id.length > 0) ? (this.allCodes.locations.find(({id}) => this.selectedCodes.location_id.includes(id)).code) : 'All',
              locationNames: this.locationNames,
              sets: (this.selectedCodes.set_id && this.selectedCodes.set_id.length > 0) ? (this.allCodes.sets.find(({id}) => this.selectedCodes.set_id.includes(id)).code) : 'All',
              setNames: this.setNames,
              // free_fields: (this.selectedCodes.free_field_1_id && this.selectedCodes.free_field_1_id.length > 0) ? (this.allCodes.freefield1.find(({id}) => this.selectedCodes.free_field_1_id.includes(id)).code) : 'All',
              free_fields: this.freeFieldNames,
              sourcecodes: (this.selectedCodes.source_code_id && this.selectedCodes.source_code_id.length > 0) ? (this.allCodes.sourcecodes.find(({id}) => this.selectedCodes.source_code_id.includes(id)).code) : 'All',
              accounts: capitalizeFirstLetter(this.reportOptions.accountQuickPick),
              ids: undefined,
              grand_total: 0,
              data: []
            }
          }

          let rawData = {}

          // Transform data from account to transaction based array
          for (let index in sortedTransactions['current']) {
            const accounts = sortedTransactions['current'][index]
            accounts.map((line) => {
              if (line && line.trans_number) {
                const transNumber = line.trans_number

                if (!rawData[transNumber]) {
                  rawData[transNumber] = []
                }
                rawData[transNumber].push(line)
                // rawData[transNumber].detail.push(line)
              }
            })
          }

          // Each item in rawData should be its own PO so transform each one into Jasper JSON object
          if (Object.keys(rawData).length > 0) {
            for (let i in rawData) {
              const po = rawData[i] // SORT by id, line_number
              let poObject = {}
              poObject.trans_number = po[0].trans_number
              poObject.transaction_type = 'PO'
              poObject.transaction_desc = po[0].transaction_description
              poObject.document_amount = po[0].transaction_amount_decimal
              poObject.amount_calculated = 0
              poObject.amount_remaining = 0
              poObject.amount_distributed = 0
              poObject.doc_number = po[0].doc_number
              poObject.doc_date = po[0].doc_date
              poObject.effective_date = po[0].transaction_effective_date
              poObject.vendor = po[0].vendor_name
              poObject.detail = []

              po.map(line => {
                if (line.line_type === 'OPEN' || line.line_type === 'PARTIAL' || line.line_type === 'TRANSFERRED') {
                  poObject.amount_calculated += parseFloat(line.amount)
                  line.amount = parseFloat(line.amount)
                  poObject.detail.push(line)
                  // console.log(line)
                } else if (line.line_type === 'CLOSED') {
                  poObject.amount_calculated += parseFloat(line.amount)
                } else if (line.line_type === 'ADJUSTMENT') {
                  poObject.amount_distributed += parseFloat(line.amount) * -1
                } else if (line.line_type === 'RELIEF') {
                  poObject.amount_distributed += parseFloat(line.amount) * -1
                  // console.log(line.referencing_line_id)
                  let originalLine = poObject.detail.find((d) => parseInt(d.line_id) === parseInt(line.referencing_line_id)) || {}
                  // console.log(originalLine.line_id, originalLine.amount, line.amount)
                  originalLine.amount += parseFloat(line.amount)
                  // poObject.detail.push(line)
                } else {
                  console.log(line)
                }
              })
              poObject.amount_remaining = poObject.detail.reduce((a, line) => { return a + line.amount }, 0)
              // if (Math.round(poObject.amount_remaining * 100) !== 0) {
              //   json.report.grand_total += poObject.amount_remaining
              //   json.report.data.push(poObject)
              // }
              json.report.grand_total += poObject.amount_remaining
              json.report.data.push(poObject)
            }
          }
          this.result = json.report.data
          if (this.jasperSettings.reportSubtitle === 'Sorted by Transaction') {
            this.sortStrings()
          }
          json.report.data = this.jasperSettings.reportSubtitle === 'Sorted by Transaction' ? this.result : sortObjectByProperty(json.report.data, 'doc_number')
          // Sort by transaction number
          json.report.ids = json.report.data.length
          resolve(json)
        })
      },
      sortStrings () {
        this.result = this.result
        .map(obj => {
          const numericPart = parseInt(obj.trans_number.match(/\d+/)[0])
          return { ...obj, numericPart }
        })
        .sort((a, b) => a.numericPart - b.numericPart)
        .map(obj => {
          const { value, ...rest } = obj
          return { value: obj.trans_number, ...rest }
        })
      },
      buildPoReport (sortedTransactions) {
        return this.buildTransReport(sortedTransactions)
      },
      buildVendorReport (sortedTransactions) {
        return new Promise((resolve, reject) => {
          let json = {
            'report': {
              report_name: this.jasperSettings.report_name,
              report_title: this.jasperSettings.reportTitle,
              report_subtitle: this.jasperSettings.reportSubtitle,
              printed_by: this.username,
              date_run: this.today(),
              company: (this.selectedCodes.company_id) ? (this.allCodes.companies.find(({id}) => id === this.selectedCodes.company_id).name) : this.allCodes.companies[0].name,
              project:
                this.selectedCodes.production_id && this.selectedCodes.production_id.length
                ? this.allCodes.productions.filter((prod) => this.selectedCodes.production_id.includes(prod.id)).map((prod) => prod.name).join(', ')
                : this.allCodes.productions[0].name,
              // period: (this.selectedCodes.period_start || 'Beginning') + ' - ' + (this.selectedCodes.period_end || 'End'),
              currency: (this.reportOptions.report_currency_id) ? (this.allCodes.currencies.find(({id}) => id === this.reportOptions.report_currency_id).code) : this.currencies[0].code,
              // date_start: (this.selectedCodes.period_start) ? (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start).start) : '0000/00/00',
              // date_end: (this.selectedCodes.period_end) ? (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end).end) : this.today(),
              period: this.dateStart + ' - ' + this.dateEnd,
              date_start: this.dateStart,
              date_end: this.dateEnd,
              transactions: 'All',
              batchNames: this.selectedCodes.batch_id.length ? this.batchNames.join(', ') : 'All',
              episodes: (this.selectedCodes.series && this.selectedCodes.series.length > 0) ? (this.allCodes.series.find(({id}) => this.selectedCodes.series.includes(id)).code) : 'All',
              seriesNames: this.seriesNames,
              locations: (this.selectedCodes.locations && this.selectedCodes.locations.length > 0) ? (this.allCodes.locations.find(({id}) => this.selectedCodes.locations.includes(id)).code) : 'All',
              locationNames: this.locationNames,
              sets: (this.selectedCodes.sets && this.selectedCodes.sets.length > 0) ? (this.allCodes.sets.find(({id}) => this.selectedCodes.sets.includes(id)).code) : 'All',
              setNames: this.setNames,
              // free_fields: (this.selectedCodes.free_field_1_id && this.selectedCodes.free_field_1_id.length > 0) ? (this.allCodes.freefield1.find(({id}) => this.selectedCodes.free_field_1_id.includes(id)).code) : 'All',
              free_fields: this.freeFieldNames,
              sourcecodes: (this.selectedCodes.source_code_id && this.selectedCodes.source_code_id.length > 0) ? (this.allCodes.sourcecodes.find(({id}) => this.selectedCodes.source_code_id.includes(id)).code) : 'All',
              accounts: capitalizeFirstLetter(this.reportOptions.accountQuickPick),
              ids: undefined,
              grand_total: undefined,
              data: undefined
            }
          }

          let rawData = []

          let vendorArray = [] // This is the first level of the report

          this.unserializedData.pos.headers.map((data) => {
            // This is the first level of the report
            if (!vendorArray[data.vendor]) {
              vendorArray[data.vendor] = {}

              vendorArray[data.vendor].id = data.vendor
              vendorArray[data.vendor].vendor_number = this.vendors.find(({id}) => { return (id === data.vendor) }).code
              vendorArray[data.vendor].vendor_name = this.vendors.find(({id}) => { return (id === data.vendor) }).name
              vendorArray[data.vendor].vendor_total = '' // data.remaining
              vendorArray[data.vendor].vendor_total_paid = null // data.remaining
              vendorArray[data.vendor].transaction = []
            }

            // This is the second level
            let transaction = {}
            transaction.trans_number = data.number
            transaction.transaction_type = 'PO'
            transaction.transaction_desc = data.description
            transaction.vendor_number = (data.vendor) ? this.vendors.find(({id}) => { return (id === data.vendor) }).code : null
            // transaction.vendor_name = (data.vendor) ? this.vendors.find(({id}) => { return (id === data.vendor) }).name : null
            transaction.amount = data.amount_decimal
            transaction.doc_type = 'PO'
            transaction.doc_amount = data.amount_decimal
            transaction.doc_number = data.number
            transaction.detail = []

            // Now look through actual data and put into the proper group
            if (sortedTransactions['current']['PO' + data.id]) {
              transaction.document_amount = this.sumRecursive(sortedTransactions['current']['PO' + data.id], 'amount')
              transaction.transaction = sortedTransactions['current']['PO' + data.id]
              transaction.detail = sortedTransactions['current']['PO' + data.id]
            }

            if (Array.isArray(transaction.detail) && transaction.detail.length > 0) vendorArray[data.vendor].transaction.push(transaction)
          })

          for (let vendorData in vendorArray) {
            vendorArray[vendorData].vendor_total = this.sumRecursive(vendorArray[vendorData].transaction, 'amount')
            rawData.push(vendorArray[vendorData])
          }

          json.report.grand_total = this.sumRecursive(rawData, 'vendor_total')
          json.report.data = rawData
          json.report.ids = rawData.length

          resolve(json)
        })
      },
      buildGlReport (sortedAccounts) {
        return new Promise((resolve, reject) => {
          let json = {
            report: {
              report_name: this.jasperSettings.report_name,
              report_title: this.jasperSettings.reportTitle,
              report_subtitle: this.jasperSettings.reportSubtitle,
              printed_by: this.username,
              date_run: this.today(),
              company: (this.selectedCodes.company_id) ? (this.allCodes.companies.find(({id}) => id === this.selectedCodes.company_id).name) : this.allCodes.companies[0].name,
              project:
                this.selectedCodes.production_id && this.selectedCodes.production_id.length
                ? this.allCodes.productions.filter((prod) => this.selectedCodes.production_id.includes(prod.id)).map((prod) => prod.name).join(', ')
                : this.allCodes.productions[0].name,
              // period: (this.selectedCodes.period_start || 'Beginning') + ' - ' + (this.selectedCodes.period_end || 'End'),
              currency: (this.reportOptions.report_currency_id) ? (this.allCodes.currencies.find(({id}) => id === this.reportOptions.report_currency_id).code) : this.currencies[0].code,
              // date_start: (this.selectedCodes.period_start) ? (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start).start) : '0000/00/00',
              // date_end: (this.selectedCodes.period_end) ? (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end).end) : this.today(),
              period: this.dateStart + ' - ' + this.dateEnd,
              date_start: this.dateStart,
              date_end: this.dateEnd,
              grand_total: '',
              transactions: 'All',
              batchNames: this.selectedCodes.batch_id.length ? this.batchNames.join(', ') : 'All',
              episodes: (this.selectedCodes.series && this.selectedCodes.series.length > 0) ? (this.allCodes.series.find(({id}) => this.selectedCodes.series.includes(id)).code) : 'All',
              seriesNames: this.seriesNames,
              locations: (this.selectedCodes.locations && this.selectedCodes.locations.length > 0) ? (this.allCodes.locations.find(({id}) => this.selectedCodes.locations.includes(id)).code) : 'All',
              locationNames: this.locationNames,
              sets: (this.selectedCodes.sets && this.selectedCodes.sets.length > 0) ? (this.allCodes.sets.find(({id}) => this.selectedCodes.sets.includes(id)).code) : 'All',
              setNames: this.setNames,
              // free_fields: (this.selectedCodes.free_field_1_id && this.selectedCodes.free_field_1_id.length > 0) ? (this.allCodes.freefield1.find(({id}) => this.selectedCodes.free_field_1_id.includes(id)).code) : 'All',
              free_fields: this.freeFieldNames,
              sourcecodes: (this.selectedCodes.source_code_id && this.selectedCodes.source_code_id.length > 0) ? (this.allCodes.sourcecodes.find(({id}) => this.selectedCodes.source_code_id.includes(id)).code) : 'All',
              accounts: capitalizeFirstLetter(this.reportOptions.accountQuickPick),
              data: []
            }
          }

          // Put finished data here
          let ledgerData = []
          // TODO Use selected accounts instead of all accounts
          this.allCodes.accounts.map((data) => {
            // Place account code into report
            let account = {}
            account.account_desc = data.name
            account.account_number = data.code
            account.account_id = data.id
            account.account_parent = data.parent

            // Now look through actual data and put into the proper group
            if (sortedAccounts['current'][data.code]) {
              const po = sortedAccounts['current'][data.code] // SORT by id, line_number
              account.trans_number = po[0].trans_number
              account.transaction_type = 'PO'
              account.transaction_desc = po[0].transaction_description
              account.document_amount = po[0].transaction_amount_decimal
              account.amount_calculated = 0
              account.amount_remaining = 0
              account.amount_distributed = 0
              account.doc_number = po[0].doc_number
              account.doc_date = po[0].doc_date
              account.effective_date = po[0].transaction_effective_date
              account.vendor = po[0].vendor_name
              account.detail = []

              // const showAllLines = this.reportOptions.status === 'open' ? false : true
              const showAllLines = false
              po.map(line => {
                if (line.line_type === 'OPEN' || line.line_type === 'PARTIAL' || line.line_type === 'TRANSFERRED') {
                  account.amount_calculated += parseFloat(line.amount)
                  line.amount = parseFloat(line.amount)
                  account.detail.push(line)
                } else if (line.line_type === 'CLOSED') {
                  account.amount_calculated += parseFloat(line.amount)
                  if (showAllLines) account.detail.push(line)
                } else if (line.line_type === 'ADJUSTMENT') {
                  account.amount_distributed += parseFloat(line.amount) * -1
                  if (showAllLines) account.detail.push(line)
                } else if (line.line_type === 'RELIEF') {
                  account.amount_distributed += parseFloat(line.amount) * -1
                  let originalLine = account.detail.find((d) => parseInt(d.line_id) === parseInt(line.referencing_line_id)) || {}
                  originalLine.amount += parseFloat(line.amount)
                  // if (showAllLines) account.detail.push(line)
                } else {
                  console.log('No Line Type')
                  console.log(line)
                }
              })
              account.amount_remaining = account.amount_calculated - account.amount_distributed

              account.account_total = account.detail.reduce((a, line) => { return a + line.amount }, 0)
              account.transaction = account.detail
              /* if (Math.round(account.amount_remaining * 100) !== 0) {
                console.log(account.trans_number)
                ledgerData.push(account)
              } */
              ledgerData.push(account)
            }
          })

          json.report.grand_total = this.sumRecursive(ledgerData, 'account_total')
          json.report.data = ledgerData

          resolve(json)
        })
      },
      generateReport () {
        this.loading = true
        this.disableReportRun = true

        if (this.reportOptions.format === 'csv') {
          this.getMultiCurrencyReportData('glreport')
            .then((resSorted) => {
              return this[this.reportOptions.reportFunction](resSorted)
            })
            .then((resData) => {
              return this.buildCsvData(resData.report.data)
              // return this[this.reportOptions.reportFunction](resSorted.data)
            })
            .then((resCsv) => {
              this.prettyJson = resCsv
              this.createNotification('Success', 'CSV is Ready. ', 'success', false, true, 'PO-Report')
              return true
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.getMultiCurrencyReportData('glreport')
            .then((resSorted) => {
              return this.reportOptions.reportFunction === 'buildPoReport'
                ? this[this.reportOptions.reportFunction](this.sortBy('po_number', resSorted))
                : this[this.reportOptions.reportFunction](resSorted)
            })
            .then(json => {
              this.reportJson = json
              this.prettyJson = JSON.stringify(json, null, 2)
              return this.getJsonUrl(json)
            })
            .then(resJsonUrl => {
              // PDF version of the report
              let report = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.pdf?net.sf.jasperreports.json.source=' + resJsonUrl
              // HTML version of the report
              let preview = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.html?net.sf.jasperreports.json.source=' + resJsonUrl
              return this.getReportUrl(report)
            })
            .then(reportUrl => {
              this.loading = false
              this.createNotification('Success', 'Report is Ready. ', 'success', reportUrl)
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      buildCsvData (sortedAccounts) {
        if (!sortedAccounts || !Array.isArray(sortedAccounts)) return false

        let detailedColumns = { 'Company': 'company_name', 'Production': 'production_name', 'Transaction Type': 'trans_type', 'Transaction ID': 'trans_number', 'Transaction Description': 'transaction_description', 'Transaction Line Description': 'line_desc', 'Account': 'account', 'Account Description': 'account_name', 'Vendor Code': 'transaction_vendor', 'Vendor Name': 'vendor_name', 'Series': 'series', 'Location': 'location', 'Set': 'set', 'FF1': 'free_field_1', 'FF2': 'free_field_2', 'Tax Code': 'tax_code', 'Asset': 'asset', 'Document Number': 'doc_number', 'Document Date': 'doc_date', 'Posting Date': 'transaction_time_posted', 'Effective Date': 'transaction_effective_date', 'Period': 'transaction_period_id', 'PO Number': 'po_number', 'Check Number': 'payment_number', 'Check Amount': 'transaction_payment_amount', 'Bank Recon': 'recon', 'Cur': 'transaction_currency', 'Amount': 'amount' }
        let summaryColumns = { 'Account': 'account_number', 'Account Description': 'account_desc', 'Amount': 'account_total' }
        // detailedColumns = { 'account_number': 'account', 'account_desc': 'account_name', 'amount': 'amount', 'account': 'account', 'period': 'transaction_period_name', 'transaction_vendor': 'vendor_name', 'vendor_id': 'transaction_vendor', 'account_header': 'account_header', 'series': 'series', 'location': 'location', 'set': 'set', 'free_field_1': 'free_field_1', 'free_field_2': 'free_field_2', 'free_field_3': 'free_field_3', 'free_field_4': 'free_field_4', 'asset': 'asset', 'tax_code': 'tax_code', 'line_desc': 'line_desc', 'recon': 'recon', 'trans_type': 'trans_type', 'trans_number': 'trans_number', 'line_number': 'line_number', 'doc_date': 'doc_date', 'doc_number': 'doc_number', 'company': 'company_name', 'production': 'production_name', 'batch': 'transaction_batch_name', 'transaction_credits_decimal': 'transaction_credits_decimal', 'transaction_number': 'doc_number', 'transaction_confirmation_number': 'transaction_confirmation_number', 'transaction_original_trx_number': 'transaction_original_trx_number', 'transaction_ledger': 'transaction_ledger_id', 'transaction_description': 'transaction_description', 'transaction_date': 'doc_date', 'transaction_time_posted': 'transaction_time_posted', 'transaction_batch': 'transaction_batch', 'transaction_source_code': 'source_code', 'transaction_effective_date': 'transaction_effective_date', 'transaction_debits_decimal': 'transaction_debits_decimal', 'transaction_status': 'transaction_status', 'transaction_id': 'subledger_id', 'transaction_period': 'transaction_period_id', 'payment_number': 'payment_number', 'transaction_date_due': 'transaction_date_due', 'transaction_vendor_code': 'transaction_vendor', 'transaction_payment_combine_checks': 'transaction_payment_combine_checks', 'transaction_payment_check_split': 'transaction_payment_check_split', 'transaction_state': 'transaction_state', 'transaction_discount_decimal': 'transaction_discount_decimal', 'transaction_payment_check_pickup': 'transaction_payment_check_pickup', 'transaction_payment_type': 'transaction_payment_type', 'transaction_payment_confirmation_number': 'transaction_payment_confirmation_number', 'transaction_amount_decimal': 'transaction_amount_decimal' }
        // let sipraColumnMap = { 'account_number': 'account', 'account_desc': 'account_name', 'amount': 'amount', 'account': 'account', 'period': 'transaction_period_name', 'transaction_vendor': 'vendor_name', 'vendor_id': 'transaction_vendor', 'account_header': 'account_header', 'series': 'series', 'location': 'location', 'set': 'set', 'free_field_1': 'free_field_1', 'free_field_2': 'free_field_2', 'free_field_3': 'free_field_3', 'free_field_4': 'free_field_4', 'asset': 'asset', 'tax_code': 'tax_code', 'line_desc': 'line_desc', 'recon': 'recon', 'trans_type': 'trans_type', 'trans_number': 'trans_number', 'doc_date': 'doc_date', 'doc_number': 'doc_number', 'company': 'company_name', 'production': 'production_name', 'batch': 'transaction_batch_name', 'transaction_credits_decimal': 'transaction_credits_decimal', 'transaction_number': 'doc_number', 'transaction_confirmation_number': 'transaction_confirmation_number', 'transaction_original_trx_number': 'transaction_original_trx_number', 'transaction_ledger': 'transaction_ledger_id', 'transaction_description': 'transaction_description', 'transaction_date': 'doc_date', 'transaction_time_posted': 'transaction_time_posted', 'transaction_batch': 'transaction_batch', 'transaction_source_code': 'source_code', 'transaction_effective_date': 'transaction_effective_date', 'transaction_debits_decimal': 'transaction_debits_decimal', 'transaction_status': 'transaction_status', 'transaction_id': 'subledger_id', 'transaction_period': 'transaction_period_id', 'payment_number': 'payment_number', 'transaction_date_due': 'transaction_date_due', 'transaction_vendor_code': 'transaction_vendor', 'transaction_payment_combine_checks': 'transaction_payment_combine_checks', 'transaction_payment_check_split': 'transaction_payment_check_split', 'transaction_state': 'transaction_state', 'transaction_discount_decimal': 'transaction_discount_decimal', 'transaction_payment_check_pickup': 'transaction_payment_check_pickup', 'transaction_payment_type': 'transaction_payment_type', 'transaction_payment_confirmation_number': 'transaction_payment_confirmation_number', 'transaction_amount_decimal': 'transaction_amount_decimal' }

        // TODO: Sipra Output
        let columnMap = (this.reportOptions.type === 'summary') ? summaryColumns : detailedColumns

        return new Promise((resolve, reject) => {
          let ledgerData = []

          sortedAccounts.map(accountCode => {
            if (this.reportOptions.type === 'summary') {
              accountCode.detail = undefined
              ledgerData.push(accountCode)
            } else {
              accountCode.detail.map(row => ledgerData.push(row))
            }
          })

          this.disableReportRun = false
          let finalCsv = this.createCsv(ledgerData, columnMap)
          if (finalCsv) resolve(finalCsv)
          else reject('Could not build CSV.')
        })
      },
      sortBy (sortKey, data) {
        const results = { current: {} }
        const lines = []
        const keys = new Set()

        for (const key of Object.keys(data.current)) {
          lines.push(...data.current[key])
        }

        for (const line of lines) {
          keys.add(line[sortKey])
        }

        const sorted = Array.from(keys).sort((a, b) => {
          return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' })
        })

        for (const sortKey of sorted) {
          Object.assign(results.current, { [sortKey]: [] })
        }

        for (const line of lines) {
          results.current[line[sortKey]].push(line)
        }

        return results
      }
    },

    beforeCreate () {
    },

    created () {
      // Load data to be used for validation
      this.loading = true
      this.disableReportRun = true

      this.getBatchList()
        .then(() => {
          this.batches.sort(function (a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          })
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
          this.disableReportRun = false
        })

      this.getCompanyData()
        .then((response) => {
          this.allCodes = Object.assign({}, response.data)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.reportOptions.report_currency_id = this.allCodes.currencies.find((c) => c.is_base).id
        })

      this.getVendorData()
        .then((response) => {
          this.vendors = sortObjectByProperty(response.data, 'code')
        })
        .catch((error) => {
          console.log(error)
        })
    },

    beforeDestroy () {
      this.resetComponent()
    }
  }
  
</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
</style>
<style>
  #poreport .el-select { display: block; }
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>



// WEBPACK FOOTER //
// src/components/Reports/PoReportCustom.vue